import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";

export default class KeyDecisionUnderlayScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory
     * @param {AssetLibrary} assetLibrary
     * @param {SoundManager} soundManager
     * @param {SoundConfig} soundConfig
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, assetLibrary,soundManager,soundConfig) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._assetLibrary = assetLibrary;
        this._soundManager = soundManager;
        this._soundConfig = soundConfig;

        this._transitionInDuration = this.getCustomData().transitionInDuration || 0;
        this._waitBeforeSuspenseAnimation = this.getCustomData().waitBeforeSuspenseAnimation || 0;
        this._backgroundImageId = this.getCustomData().backgroundImageId;
    }

    initialize() {
        super.initialize();

        if (this._backgroundImageId) {
            this._showBackgroundImage();
        }

        this._animIn();
    }

    destroy() {
        this._target.imageContainer.removeAllChildren();
        this._stopBackgroundAudio();
        super.destroy();
    }

    _showBackgroundImage() {
        const image = this._assetLibrary.getAsset(this._backgroundImageId);
        const bitmap = new createjs.Bitmap(image);

        // Center bitmap
        const bitmapBounds = bitmap.getBounds();
        bitmap.x = -bitmapBounds.width * .5;
        bitmap.y = -bitmapBounds.height * .5;

        const backgroungAudioId = this._soundConfig.getSoundId(this._backgroundImageId);
        this._playBackgroundAudio(backgroungAudioId);
        this._target.imageContainer.addChild(bitmap);

    }

    _animIn() {
        this._target.topBar.alpha = 0;
        this._target.topBar.initialY = this._target.topBar.y;
        this._target.topBar.y -= this._target.topBar.getBounds().height;
        createjs.Tween.get(this._target.topBar)
            .wait(this._transitionInDuration + this._waitBeforeSuspenseAnimation)
            .to({ alpha: 1, y: this._target.topBar.initialY }, 450, createjs.Ease.sineOut);

        this._target.bottomBar.alpha = 0;
        this._target.bottomBar.initialY = this._target.bottomBar.y;
        this._target.bottomBar.y += this._target.bottomBar.getBounds().height;
        createjs.Tween.get(this._target.bottomBar)
            .wait(this._transitionInDuration + this._waitBeforeSuspenseAnimation)
            .to({ alpha: 1, y: this._target.bottomBar.initialY }, 450, createjs.Ease.sineOut);
    }
}